module.exports = __webpack_public_path__ + "img/Greece.335d5961.gif";